export enum MessageTemplateAction {
    FormSent = 1,
    FormIncompleteReminder
}